import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "faq",
  class: "container md:w-[700px] mx-auto py-24 sm:py-32"
}

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/landingPage/ui/accordion";

interface FAQProps {
  question: string;
  answer: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const FAQList: FAQProps[] = [
  {
    question: "À qui s'adresse Autrement Capable ?",
    answer: "La plateforme s'adresse aux jeunes neurodivergents (notamment avec TSA) qui souhaitent découvrir leurs forces et construire leur projet professionnel, aux accompagnateurs (parents, enseignants, éducateurs, psychologues), et aux entreprises inclusives souhaitant recruter des talents neurodivergents.",
    value: "item-1",
  },
  {
    question: "Comment fonctionne le système de matching ?",
    answer:
      "Notre algorithme d'intelligence artificielle analyse les données collectées via les mini-jeux et activités pour créer un profil unique. Il recommande ensuite des métiers, formations et entreprises compatibles selon vos compétences, préférences, localisation et type de travail souhaité.",
    value: "item-2",
  },
  {
    question: "Mes données personnelles sont-elles sécurisées ?",
    answer:
      "Absolument. Toutes vos données sont chiffrées et hébergées de façon sécurisée. Nous respectons le RGPD et vous gardez le contrôle total sur les informations que vous partagez. Vous pouvez à tout moment consulter, modifier ou supprimer vos données.",
    value: "item-3",
  },
  {
    question: "Quel est le rôle de l'accompagnateur sur la plateforme ?",
    answer: "Les accompagnateurs ont accès à un tableau de bord dédié pour suivre les progrès des jeunes, analyser les données, communiquer via messagerie sécurisée, ajouter des notes et recommandations, et créer des ateliers interactifs personnalisés.",
    value: "item-4",
  },
  {
    question: "Comment les entreprises peuvent-elles utiliser la plateforme ?",
    answer: "Les entreprises peuvent publier des offres d'emploi inclusives, découvrir des profils de candidats neurodivergents, bénéficier de formations à la neurodiversité et suivre l'intégration des candidats recrutés pour assurer une transition réussie.",
    value: "item-5",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center mb-8" }, [
      _createElementVNode("h2", { class: "text-lg text-[#ff9500] text-center mb-2 tracking-wider" }, "FAQ"),
      _createElementVNode("h2", { class: "text-3xl md:text-4xl text-center font-bold" }, " Questions fréquentes ")
    ], -1)),
    _createVNode(_unref(Accordion), {
      type: "single",
      collapsible: "",
      class: "AccordionRoot"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FAQList, ({ question, answer, value }) => {
          return _createVNode(_unref(AccordionItem), {
            key: value,
            value: value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordionTrigger), { class: "text-left" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(question), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(AccordionContent), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(answer), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"])
        }), 64))
      ]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-medium mt-4" }, [
      _createTextVNode(" Vous avez d'autres questions ? "),
      _createElementVNode("a", {
        href: "#contact",
        class: "text-[#ff9500] underline"
      }, "Contactez-nous")
    ], -1))
  ]))
}
}

})